import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';


function TabPanel(props) {
   const { children, value, index } = props;

   return (
     <Typography
       component="div"
       role="tabpanel"
       hidden={value !== index}
       id={`scrollable-prevent-tabpanel-${index}`}
       aria-labelledby={`scrollable-prevent-tab-${index}`}
     >
       <Box p={5}>{children}</Box>
     </Typography>
   );
 }

 TabPanel.propTypes = {
   children: PropTypes.node,
   index: PropTypes.any.isRequired,
   value: PropTypes.any.isRequired,
 };

 function a11yProps(index) {
   return {
       id: `simple-tab-${index}`,
       'aria-controls': `simple-tabpanel-${index}`,
   };
 }


 const StyledTabs = withStyles({

   indicator: {
     display: 'flex',
     justifyContent: 'center',
     backgroundColor: 'transparent',
     '& > div': {
       //maxWidth: 80,
       width: '80px',
       backgroundColor: '#1aaecc',
     },
   },
 })(props => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);


 const AntTab = withStyles(theme => ({
   root: {
     '&$selected': {
       color: '#1aaecc',
       fontWeight: theme.typography.fontWeightMedium,
     },
     '&:focus': {
       color: '#1aaecc',
       outline: "none"

     },
     '&:hover': {
       color: '#1aaecc',
     },
   },
   selected: {},
 }))(props => <Tab disableRipple {...props} />);



 const TabSlider  = (props) => {

   const theme = useTheme();
   //const [value, setValue] = React.useState(0);

  //  const handleChange = (event, newValue) => {
  //    setValue(newValue);
  //  };

   return (
     <div className="ProductPanel">
       <AppBar position="static" color="default">
         <StyledTabs
              value={props.tabIndex}
              onChange={props.handleChangeTab}
              //variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable prevent tabs example"
         >
        {props.antTabArr.map((elem, index) => (
             <AntTab key={index} className="tabs" label={elem.titel} {...a11yProps(index)} />
        ))}
         </StyledTabs>
       </AppBar>
            <TabPanel value={props.tabIndex} index={props.tabIndex} dir={theme.direction}>
                {props.tabPanelArr[props.tabIndex].map((elem, index) => (
                    <div key={index}
                      onClick={props.onClick}
                      index={index}
                      titel={elem.titel}
                      form={elem.form}
                      className={elem.form === 'Gerade'?'tab_wrapper_gerade':'tab_wrapper_geschwungen'}>
                        <img className={props.imgClassName} src={elem.product_img} alt={elem.titel}/>
                        <p>{elem.titel}</p>
                    </div>
                ))}
          </TabPanel>
     </div>
   );
 }

 export default TabSlider;

